import React from 'react';

import { MobileListProvider } from './MobileListContext';
import { MobileNavigationGuard } from './MobileNavigationGuard';
import { MobileHeader } from './MobileHeader';
import { MobileMenuOverlay } from './MobileMenuOverlay';
import { PushNotificationManager } from './PushNotificationManager';

type MobileShellProps = {
  children: React.ReactNode;
};

export function MobileShell({ children }: MobileShellProps) {
  const navigationButtonRef = React.useRef<HTMLButtonElement>(null);
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const openMenu = React.useCallback(() => setIsMenuOpen(true), []);
  const closeMenu = React.useCallback(() => setIsMenuOpen(false), []);

  return (
    <MobileListProvider><MobileNavigationGuard><div className="relative flex min-h-svh flex-col bg-background text-foreground">
      {/* Initialize push notifications (mobile only, no visible UI by default) */}
      <PushNotificationManager />

      <MobileHeader onLogoPress={openMenu} navigationButtonRef={navigationButtonRef} />
      <div data-mobile-list-scroll className="flex-1 min-w-0 overflow-y-auto px-3 safe-area-pb-6 pt-4 sm:px-4 [&_[data-mobile-create-placeholder]]:hidden">
        {children}
      </div>
      <MobileMenuOverlay open={isMenuOpen} onClose={closeMenu} returnFocusRef={navigationButtonRef} />
    </div></MobileNavigationGuard></MobileListProvider>
  );
}
